import {
  Box,
  Container,
  Typography
} from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../common/button/CustomButton";
import CarouselWithCards from "../../../common/Post/CarouselWithCards";
import { usePostStore } from "../../../store/postStore";
import { getCategories } from "../../../services/api/post/getPosts";

const CaseStudy = () => {
  const navigate = useNavigate();
  const { achievementsLoading, achievements, getAchievements } = usePostStore();

  useEffect(() => {
    getCategories("achievementservice");
    getAchievements("achievementservice");
  }, [getAchievements]);
  return (
    <Box
      // py={5}
      sx={{
        py: {
          xs: 6,
          sm: 8,
        },
        // backgroundImage: `url(${StrengthBg})`, // Use the imported image here
        // backgroundSize: "cover", // Cover the entire box
        // backgroundPosition: "center", // Center the image
        // height: "100vh", // Full viewport height
        width: "100%", // Full viewport width
        // display: "flex",
        // flexDirection: "column",
        // justifyContent: "center",
        // alignItems: "center",
        // textAlign: "center",
        color: "#fff",
        backgroundColor: "#F8F8F8",
      }}
    >
      <Container>
        <Box
        // sx={{
        //   px: { xs: 2, md: 10 },
        // }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              background: "linear-gradient(180deg, #F8B62D 0%, #EA5514 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontWeight: 700,
              fontSize: {
                xs: "14px",
                sm: "24px",
              },
              lineHeight: "33px",
              marginBottom: 0,
            }}
          >
            Case Study
          </Typography>
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontWeight: 700,
              fontSize: {
                xs: "18px",
                sm: "50px",
              },
              color: "#000000",
              lineHeight: { xs: '20px', md: "70px" },

            }}
          >
            主なプロジェクト実績紹介
          </Typography>
          <Typography
            // mt={6}
            variant="body1"
            gutterBottom
            sx={{
              fontWeight: 400,
              lineHeight: "36px",
              fontSize: {
                xs: "14px",
                sm: "20px",
              },
              color: "#000000",
              mt: {
                xs: 0,
                sm: 3,
              },
            }}
          >
            戦略立案から施策実行まで多様なケースで企業の課題解決をご支援
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            sx={{
              fontWeight: 400,
              lineHeight: "36px",
              fontSize: "20px",
              color: "#000000",
            }}
          >
            技術力とコストパフォーマンスに高い評価をいただいています。
          </Typography>

          <CarouselWithCards posts={achievements} slug={"achievementservice"} loading={achievementsLoading} />

          <Box
            onClick={() => navigate("/achievements")}
            display="flex"
            justifyContent="center"
            mt={4}
          >
            <CustomButton text="実績の一覧を見る" />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default CaseStudy;
